import GoLoading from "./vueCom/goLoading/index";
// form控件
import goFormCtl from "./vueCom/formVue/index";
//常规控件
import goCommonCtl from "./vueCom/ctlVue/index";

//布局控件
import goLayoutCtl from "./vueCom/layoutVue/index";
//界面级别的控件
import pageVueCtl from "./vueCom/pageVue/index";

import locale from './locale/index';
//下拉组件
import CommonCtl from './jsCom/comCtl/index';
//dx组件初始化api
import DxUtils from './dx/index';
//窗口组件
import GoDialog from './jsCom/go-dialog';
//窗口相关的工具类
import WinUtils from './winUtils';
//附件相关的工具类
import FileUtils from './jsCom/utils/FileUtils';

import initDrective from './directive/directiveUtils';

const components = {
    GoLoading,
    ...goFormCtl,
    ...goCommonCtl,
    ...goLayoutCtl,
    ...pageVueCtl
};

const goingui = {
    ...components,
};

const install = function(Vue, opts = {}) {
    //自定义指令
    initDrective(Vue);

    if (install.installed) return;
    locale.use(opts.locale);
    locale.i18n(opts.i18n);

    Object.keys(goingui).forEach(key => {
        Vue.component(key, goingui[key]);
    });


    Vue.prototype.$WinUtils = WinUtils;
    Vue.prototype.$goDialog = GoDialog;
    Vue.prototype.$CommonCtl = CommonCtl;
    Vue.prototype.$FileUtils=FileUtils;
    Vue.prototype.$dxUtils=DxUtils;
};

// auto install
if (typeof window !== 'undefined' && window.Vue) {
    install(window.Vue);
}

const API = {
    version: process.env.VERSION, // eslint-disable-line no-undef
    locale: locale.use,
    i18n: locale.i18n,
    install,
    ...components
};

API.lang = (code) => {
    const langObject = window['goingui/locale'].default;
    if (code === langObject.i.locale) locale.use(langObject);
    else console.log(`The ${code} language pack is not loaded.`); // eslint-disable-line no-console
};

module.exports.default = module.exports = API;   // eslint-disable-line no-undef



// WEBPACK FOOTER //
// ./goingsrc/index.js